import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import SectionHeader from "../SectionHeader";
import products from "../../data/products";

const ProductShowcase = () => {
  const [active, setActive] = useState(0);
  const product = products[active];

  return (
    <section className="section">
      <SectionHeader
        eyebrow="Our products"
        title="Five products. One platform DNA."
        lead="Start with the system your business needs today. Each Byteflow product is built on the same foundation — fast to deploy, easy to train, and ready to scale."
      />

      <div
        className="showcase-tabs"
        role="tablist"
        aria-label="Byteflow products"
      >
        {products.map((p, i) => (
          <button
            key={p.slug}
            type="button"
            role="tab"
            aria-selected={i === active}
            className={"showcase-tab" + (i === active ? " is-active" : "")}
            style={{ "--product-accent": p.accent }}
            onClick={() => setActive(i)}
          >
            <span aria-hidden>{p.icon}</span> {p.shortName}
            {p.flagship && <span className="showcase-tab__badge">Flagship</span>}
          </button>
        ))}
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={product.slug}
          className="showcase-panel"
          style={{ "--product-accent": product.accent }}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.35 }}
        >
          <div className="showcase-panel__body">
            <h3>
              <span aria-hidden>{product.icon}</span> {product.name}
            </h3>
            <p className="showcase-panel__tagline">{product.tagline}</p>
            <p>{product.blurb}</p>
            <ul className="showcase-panel__features">
              {product.features.slice(0, 8).map((f) => (
                <li key={f.title}>
                  <span aria-hidden>{f.icon}</span> {f.title}
                </li>
              ))}
            </ul>
            <div className="showcase-panel__ctas">
              <Link to={`/products/${product.slug}`} className="btn-primary">
                Explore {product.shortName} →
              </Link>
              <Link to="/contact" className="btn-secondary">
                Talk to sales
              </Link>
            </div>
          </div>
          <div className="showcase-panel__media">
            <img src={product.image} alt={`${product.name} preview`} />
          </div>
        </motion.div>
      </AnimatePresence>

      <p className="showcase-footer">
        Not sure where to start?{" "}
        <Link to="/products">Compare all products</Link> or{" "}
        <Link to="/contact">ask us — we'll point you right</Link>.
      </p>
    </section>
  );
};

export default ProductShowcase;
